import { createFileRoute } from '@tanstack/react-router'
import Assets from '@/features/assets'
import { ProtectedRoute } from '@/components/auth/protected-route'
import { Permissions } from '@/constants/roles-permissions'

export const Route = createFileRoute('/_authenticated/assets')({
  component: AssetsRoute,
})

function AssetsRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.AssetView}>
      <Assets />
    </ProtectedRoute>
  )
} 